/* eslint-disable no-magic-numbers, class-methods-use-this */
import Phase from '../phase-core/Phase';

const tyr = [ /* WARDRUNNA TYR */
	[30, -90],
	[35, -80],
	[50, -80],
	[52, -60],
	[70, -50],
	[84, -40],

	[121, -40],
	[186, -40],
	[242, -40],
	[363, -40],
	[431, -40],
	[485, -40],
	[556, -45],
	[613, -45],
	[680, -50],
	[743, -50],
	[801, -55],
	[860, -55],
	[920, -65],
	[990, -65],
	[1050, -70],
	[1100, -70],
	[1170, -80],
	[1240, -80],
];

export default class TyrFeedback extends Phase {

	getBeatLength() {
		return this.length;
	}

	getPreludeLength() {
		return 0;
	}

	getPostludeLength() {
		return 0;
	}

	run({ passage, period, feedback_opts }) {
		let master = 0;
		let feedback = 0;
		if (passage < 0.45) {
			master = passage / 0.9;
			feedback = 0;
		} else if (passage < 0.55) {
			master = 0.5;
			feedback = (passage - 0.45) / 0.1 * 0.7;
		} else if (passage < 0.6) {
			master = 0.5;
			feedback = 0.7;
		} else if (passage < 0.9) {
			master = 0.5;
			feedback = 1.9 - 2 * passage;
		} else if (passage < 1) {
			master = (passage - 0.9) * 0.5 + 0.5;
			feedback = 0.1;
		}
		feedback_opts.master_level = master;
		feedback_opts.feedback_level = feedback;
		feedback_opts.speed = period;
		feedback_opts.spectrum = new Map(tyr);
	}

}
